import * as React from "react"
import Box from "@mui/material/Box"
import TabsWrappedLabel from "../../../../components/tabs/tabs-component"
import PropTypes from "prop-types"

const EmissionTabsWrappedLabel = ({
    emissionTabChildren,
    eventFlowTabChildren,
    documentsChildren,
}) => {
    return (
        <Box
            sx={{
                width: "100%",
            }}
        >
            <TabsWrappedLabel
                tabs={[
                    {
                        value: "emission",
                        label: "EMISSÃO",
                        content: emissionTabChildren,
                    },
                    {
                        value: "eventFlow",
                        label: "FLUXO DE EVENTOS",
                        content: eventFlowTabChildren,
                    },
                    {
                        value: "documents",
                        label: "DOCUMENTOS",
                        content: documentsChildren,
                    },
                ]}
            />
        </Box>
    )
}

EmissionTabsWrappedLabel.propTypes = {
    emissionTabChildren: PropTypes.node,
    eventFlowTabChildren: PropTypes.node,
    documentsChildren: PropTypes.node,
}

export default EmissionTabsWrappedLabel
